import { WidgetType } from 'widgets/WidgetType';

export class WidgetStreamRegistrationManager {
    private registrations: { [key: string]: number } = {};

    public register(widgetType: WidgetType, widgetKey: string) {
        return this.increment(widgetType, widgetKey, 1);
    }

    public deRegister(widgetType: WidgetType, widgetKey: string) {
        return this.increment(widgetType, widgetKey, -1);
    }

    private increment(
        widgetType: WidgetType,
        widgetKey: string,
        increment: number
    ): number {
        const regCount = this.getRegistration(widgetType, widgetKey);
        const nextRegCount = regCount + increment;
        this.setRegistration(widgetType, widgetKey, nextRegCount);
        return nextRegCount;
    }

    private toKey(widgetType: WidgetType, widgetKey: string) {
        return `${widgetType}-${widgetKey}`;
    }

    private getRegistration(widgetType: WidgetType, widgetKey: string) {
        return this.registrations[this.toKey(widgetType, widgetKey)] ?? 0;
    }

    private setRegistration(
        widgetType: WidgetType,
        widgetKey: string,
        value: number
    ) {
        this.registrations[this.toKey(widgetType, widgetKey)] = value;
    }
}
